.content {
  font-size: 15px;
  font-weight: 300;
  font-kerning: none;
  line-height: 1.8;
  color: #000;
  white-space: pre-wrap;
}

.content2015 {
  font-size: 14px;
  line-height: 22px;
  overflow-wrap: break-word;
  white-space: pre-wrap;

  a {
    display: inline-block;
    color: #358cda;

    &:hover {
      text-decoration: underline;
    }
  }
}

@container press-release-root (min-width: 1024px) {
  .contentCQ {
    font-size: 18px;
  }

  .content2015CQ {
    font-size: 13px;
    line-height: 1.7em;
  }
}

@media screen and (width >= 1024px) {
  .contentFallback {
    font-size: 18px;
  }

  .content2015Fallback {
    font-size: 13px;
    line-height: 1.7em;
  }
}
